import React from 'react'
import './about.scss'
import { Hero, Sidebar, MainHeading , Breadcrumb , AboutMain , FindAgent} from '../../../components';
import { images } from "../../../utils/customFn";
import { Row, Col, Container } from 'react-bootstrap';
const About = () => {
  const breadcrumbs = [
    { label: "Sentry Insurance home", link: "/" },
    { label: "About us", link: "/aboutus" },
  ];
  const Selectoptions = [
    { value: 'Constructions', label: 'Constructions' },
    { value: 'DealerShip', label: 'DealerShip' },
    { value: 'Manufacturing and process industries', label: 'Manufacturing and process industries' },
    { value: 'Retailers and Distributors', label: 'Retailers and Distributors' },
    { value: 'Service industries', label: 'Service industries' },
    { value: 'Trucking', label: 'Trucking' },
  ];
  return (
    <>
      {/* hero section */}
      <Hero img={images["about-us-hero.avif"]} />
      <Container>
        {/* Breadcrumb */}
        <Breadcrumb crumbs={breadcrumbs}/>
        {/* heading  */}
        <MainHeading title="About"/>
        {/* Layout */}
        <Row>
          <Col sm={12} md={12} lg={6} xl={8}>
              <AboutMain/>
          </Col>
          <Col sm={12} md={6} lg={6} xl={4}>
            <Sidebar />
          </Col>
        </Row>
        <FindAgent options={Selectoptions}/>
      </Container>
    </>
  )
}

export default About